var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2317 24.06L16.0257 21.54H15.9717V30H13.3977V17.436H16.3857L19.8237 23.376L21.0297 25.896H21.0837V17.436H23.6577V30H20.6697L17.2317 24.06ZM26.2791 20.55H28.9431V22.134H29.0331C29.1651 21.606 29.4651 21.174 29.9331 20.838C30.4131 20.502 30.9591 20.334 31.5711 20.334C32.7711 20.334 33.6771 20.754 34.2891 21.594C34.9011 22.434 35.2071 23.658 35.2071 25.266C35.2071 26.874 34.9011 28.104 34.2891 28.956C33.6771 29.796 32.7711 30.216 31.5711 30.216C31.2591 30.216 30.9651 30.168 30.6891 30.072C30.4131 29.988 30.1611 29.868 29.9331 29.712C29.7171 29.544 29.5311 29.352 29.3751 29.136C29.2191 28.908 29.1051 28.668 29.0331 28.416H28.9431V33.6H26.2791V20.55ZM30.6891 28.056C31.1931 28.056 31.6071 27.882 31.9311 27.534C32.2671 27.174 32.4351 26.694 32.4351 26.094V24.456C32.4351 23.856 32.2671 23.382 31.9311 23.034C31.6071 22.674 31.1931 22.494 30.6891 22.494C30.1851 22.494 29.7651 22.62 29.4291 22.872C29.1051 23.112 28.9431 23.448 28.9431 23.88V26.67C28.9431 27.102 29.1051 27.444 29.4291 27.696C29.7651 27.936 30.1851 28.056 30.6891 28.056Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 10,
    r: 4,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b9465ffe76979afd57605d08ae711413.svg";
export { ForwardRef as ReactComponent };